module.exports = __webpack_public_path__ + "static/media/9.9_wanliu.png";